module.exports = __webpack_public_path__ + "components/flag/static/square/iq-f23e22b8d2895996233c51d413619e9d.svg";